export var docElement = document.documentElement;